// extracted by mini-css-extract-plugin
export default {"arrow":"styles_arrow__qmdiU","itemContainer":"styles_itemContainer__YDt-z"};